import { Grid, theme } from "antd";
const { useBreakpoint } = Grid;
const { useToken: useTokenAntd } = theme;

export function useToken() {
  const { token } = useTokenAntd();
  const screens = useBreakpoint();

  return { token, screens };
}
